import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { ReviewProgressIcon } from './ReviewProgressIcon';
import { StatusIndicator } from './StatusIndicator';

export const ReviewedBadge: FunctionComponent<{ readonly isActive: boolean }> = ({ isActive }) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <StatusIndicator
            className={isActive ? 'text-white-200' : 'text-info-300'}
            data-testid="review-state-reviewed"
            icon={
                <ReviewProgressIcon
                    colorBase="currentColor"
                    colorFill="currentColor"
                    isActive={isActive}
                    progress={1}
                />
            }
        >
            {translate('pages.job-architecture-v2.job-profile-status-reviewed')}
        </StatusIndicator>
    );
};
